export interface Product {
  id: string
  name: string
  price: number
  category:
    | 'kings'
    | 'queens'
    | 'heir'
    | 'heiress'
    | 'electronics'
    | 'home'
    | 'sound'
    | 'kids'
    | 'deals'
  image: string
  badge?: string
  description?: string
}

export const products: Product[] = [
  // Kings (Men's Apparel)
  {
    id: 'kings-1',
    name: 'Street Tech Hoodie',
    price: 89.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=80&w=800',
    badge: 'New Arrival',
    description: 'Heavyweight cotton fleece with tech-wear inspired detailing.',
  },
  {
    id: 'kings-2',
    name: 'Urban Cargo Joggers',
    price: 65.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?auto=format&fit=crop&q=80&w=800',
    description: 'Utility focused design with multiple secure pockets.',
  },
  {
    id: 'kings-3',
    name: 'Oversized Graphic Tee',
    price: 45.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?auto=format&fit=crop&q=80&w=800',
    badge: 'Best Seller',
    description: 'Vintage wash cotton with puff print back graphic.',
  },
  {
    id: 'kings-4',
    name: 'Tactical Vest',
    price: 120.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1559563458-527698bf5295?auto=format&fit=crop&q=80&w=800',
    description: 'Layering essential with modular attachment points.',
  },
  {
    id: 'kings-5',
    name: 'Distressed Denim Jacket',
    price: 150.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1576871337622-98d48d1cf531?auto=format&fit=crop&q=80&w=800',
    description: 'Hand-distressed Japanese denim.',
  },
  {
    id: 'kings-6',
    name: 'Performance Windbreaker',
    price: 95.0,
    category: 'kings',
    image:
      'https://images.unsplash.com/photo-1618354691373-d851c5c3a990?auto=format&fit=crop&q=80&w=800',
    badge: 'Waterproof',
    description: 'Lightweight weather protection for the urban explorer.',
  },

  // Queens (Women's Apparel)
  {
    id: 'queens-1',
    name: 'Luxe Bomber Jacket',
    price: 135.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1594633313593-bab3825d0caf?auto=format&fit=crop&q=80&w=800',
    badge: 'New Arrival',
    description: 'Satin finish with embroidered details.',
  },
  {
    id: 'queens-2',
    name: 'High-Waist Joggers',
    price: 75.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&q=80&w=800',
    description: 'Tailored fit with premium stretch fabric.',
  },
  {
    id: 'queens-3',
    name: 'Cropped Hoodie Set',
    price: 95.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&q=80&w=800',
    badge: 'Best Seller',
    description: 'Matching crop hoodie and joggers.',
  },
  {
    id: 'queens-4',
    name: 'Statement Puffer',
    price: 165.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?auto=format&fit=crop&q=80&w=800',
    description: 'Oversized silhouette with bold color blocking.',
  },
  {
    id: 'queens-5',
    name: 'Athleisure Bodysuit',
    price: 55.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1581044777550-4cfa60707c03?auto=format&fit=crop&q=80&w=800',
    description: 'Seamless design for all-day comfort.',
  },
  {
    id: 'queens-6',
    name: 'Leather Moto Jacket',
    price: 220.0,
    category: 'queens',
    image:
      'https://images.unsplash.com/photo-1551028719-00167b16eac5?auto=format&fit=crop&q=80&w=800',
    badge: 'Limited',
    description: 'Genuine leather with asymmetric zip.',
  },

  // Heir (Boys' Apparel)
  {
    id: 'heir-1',
    name: 'Mini Streetwear Set',
    price: 55.0,
    category: 'heir',
    image:
      'https://images.unsplash.com/photo-1519457431-44ccd64a579b?auto=format&fit=crop&q=80&w=800',
    badge: 'New',
    description: 'Matching hoodie and joggers for young kings.',
  },
  {
    id: 'heir-2',
    name: 'Youth Graphic Tee',
    price: 35.0,
    category: 'heir',
    image:
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&q=80&w=800',
    description: 'Bold prints designed for self-expression.',
  },
  {
    id: 'heir-3',
    name: 'Kids Cargo Shorts',
    price: 45.0,
    category: 'heir',
    image:
      'https://images.unsplash.com/photo-1622290291468-a28f7a7dc6a8?auto=format&fit=crop&q=80&w=800',
    description: 'Durable construction for active play.',
  },
  {
    id: 'heir-4',
    name: 'Youth Windbreaker',
    price: 65.0,
    category: 'heir',
    image:
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&q=80&w=800',
    description: 'Lightweight protection in bold colors.',
  },

  // Heiress (Girls' Apparel)
  {
    id: 'heiress-1',
    name: 'Girls Hoodie Set',
    price: 60.0,
    category: 'heiress',
    image:
      'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?auto=format&fit=crop&q=80&w=800',
    badge: 'New',
    description: 'Matching set with sparkle details.',
  },
  {
    id: 'heiress-2',
    name: 'Youth Leggings',
    price: 40.0,
    category: 'heiress',
    image:
      'https://images.unsplash.com/photo-1596870230751-ebdfce98ec42?auto=format&fit=crop&q=80&w=800',
    description: 'Comfortable stretch fabric with fun patterns.',
  },
  {
    id: 'heiress-3',
    name: 'Girls Bomber Jacket',
    price: 75.0,
    category: 'heiress',
    image:
      'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&q=80&w=800',
    description: 'Satin finish with embroidered patches.',
  },
  {
    id: 'heiress-4',
    name: 'Youth Dress Set',
    price: 55.0,
    category: 'heiress',
    image:
      'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?auto=format&fit=crop&q=80&w=800',
    badge: 'Best Seller',
    description: 'Stylish and comfortable for any occasion.',
  },

  // Electronics
  {
    id: 'elec-1',
    name: 'Smart Home Hub',
    price: 129.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1558002038-1091a166111c?auto=format&fit=crop&q=80&w=800',
    badge: 'Limited',
    description: 'Central command for your connected life.',
  },
  {
    id: 'elec-2',
    name: 'Mechanical Keyboard',
    price: 180.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1595225476474-87563907a212?auto=format&fit=crop&q=80&w=800',
    description: 'Custom switches with aluminum chassis.',
  },
  {
    id: 'elec-3',
    name: 'Ultra-Wide Monitor',
    price: 499.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?auto=format&fit=crop&q=80&w=800',
    badge: 'Pro Gear',
    description: 'Immersive display for creators and gamers.',
  },
  {
    id: 'elec-4',
    name: 'Wireless Charging Mat',
    price: 55.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1616348436168-de43ad0db179?auto=format&fit=crop&q=80&w=800',
    description: 'Fast charging for multiple devices simultaneously.',
  },
  {
    id: 'elec-5',
    name: 'Portable SSD 1TB',
    price: 140.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1597872200969-2b65d56bd16b?auto=format&fit=crop&q=80&w=800',
    description: 'Rugged storage for content on the go.',
  },
  {
    id: 'elec-6',
    name: 'Streaming Camera',
    price: 220.0,
    category: 'electronics',
    image:
      'https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&q=80&w=800',
    description: 'DSLR quality in a compact webcam form factor.',
  },

  // Sound
  {
    id: 'snd-1',
    name: 'Bass Pro Wireless',
    price: 199.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&q=80&w=800',
    badge: 'Best Seller',
    description: 'Industry-leading noise cancellation.',
  },
  {
    id: 'snd-2',
    name: 'Studio Monitors Pair',
    price: 350.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&q=80&w=800',
    description: 'Flat response for accurate mixing.',
  },
  {
    id: 'snd-3',
    name: 'Portable Bluetooth Speaker',
    price: 89.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?auto=format&fit=crop&q=80&w=800',
    badge: 'Waterproof',
    description: '360-degree sound that goes anywhere.',
  },
  {
    id: 'snd-4',
    name: 'Turntable System',
    price: 299.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1545454675-3531b543be5d?auto=format&fit=crop&q=80&w=800',
    description: 'Analog warmth with modern connectivity.',
  },
  {
    id: 'snd-5',
    name: 'Podcast Mic Kit',
    price: 150.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1590602847861-f357a9332bbc?auto=format&fit=crop&q=80&w=800',
    description: 'Broadcast quality vocal reproduction.',
  },
  {
    id: 'snd-6',
    name: 'True Wireless Earbuds',
    price: 129.0,
    category: 'sound',
    image:
      'https://images.unsplash.com/photo-1572569028738-411a1971d274?auto=format&fit=crop&q=80&w=800',
    description: 'All-day battery life with transparency mode.',
  },

  // Home
  {
    id: 'home-1',
    name: 'Minimalist Desk Lamp',
    price: 75.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1507473888900-52e1adad5420?auto=format&fit=crop&q=80&w=800',
    description: 'Adjustable color temperature for any mood.',
  },
  {
    id: 'home-2',
    name: 'Geometric Planter',
    price: 45.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&q=80&w=800',
    description: 'Concrete finish for the modern urban jungle.',
  },
  {
    id: 'home-3',
    name: 'Lounge Chair',
    price: 450.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1592078615290-033ee584e267?auto=format&fit=crop&q=80&w=800',
    badge: 'Free Shipping',
    description: 'Mid-century inspired comfort.',
  },
  {
    id: 'home-4',
    name: 'Abstract Rug',
    price: 180.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1575414003591-ece8d0416c7a?auto=format&fit=crop&q=80&w=800',
    description: 'Hand-tufted wool blend.',
  },
  {
    id: 'home-5',
    name: 'Smart Coffee Maker',
    price: 220.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&q=80&w=800',
    description: 'Wake up to freshly brewed perfection.',
  },
  {
    id: 'home-6',
    name: 'Aromatherapy Diffuser',
    price: 60.0,
    category: 'home',
    image:
      'https://images.unsplash.com/photo-1602928321679-560bb453f190?auto=format&fit=crop&q=80&w=800',
    description: 'Ultrasonic technology for silent operation.',
  },

  // Kids
  {
    id: 'kid-1',
    name: 'Kids High Tops',
    price: 60.0,
    category: 'kids',
    image:
      'https://images.unsplash.com/photo-1514989940723-e8875ea6ab7d?auto=format&fit=crop&q=80&w=800',
    description: 'Durable construction for active play.',
  },
  {
    id: 'kid-2',
    name: 'Wooden Building Blocks',
    price: 40.0,
    category: 'kids',
    image:
      'https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?auto=format&fit=crop&q=80&w=800',
    description: 'Sustainable materials, endless creativity.',
  },
  {
    id: 'kid-3',
    name: 'Interactive Learning Tab',
    price: 85.0,
    category: 'kids',
    image:
      'https://images.unsplash.com/photo-1588072432836-e10032774350?auto=format&fit=crop&q=80&w=800',
    description: 'Educational games in a kid-proof case.',
  },

  // Deals
  {
    id: 'deal-1',
    name: 'Last Season Parka',
    price: 120.0,
    category: 'deals',
    image:
      'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&q=80&w=800',
    badge: '50% OFF',
    description: 'Final sale on winter essentials.',
  },
  {
    id: 'deal-2',
    name: 'Refurbished Headphones',
    price: 150.0,
    category: 'deals',
    image:
      'https://images.unsplash.com/photo-1546435770-a3e426bf472b?auto=format&fit=crop&q=80&w=800',
    badge: 'Certified',
    description: 'Like new condition with 1-year warranty.',
  },
  {
    id: 'deal-3',
    name: 'Mystery Box',
    price: 99.0,
    category: 'deals',
    image:
      'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&q=80&w=800',
    badge: 'Value $200+',
    description: 'Curated selection of random favorites.',
  },
  {
    id: 'deal-4',
    name: 'Bundle: Desk Setup',
    price: 199.0,
    category: 'deals',
    image:
      'https://images.unsplash.com/photo-1493723843684-a4368d8b6e91?auto=format&fit=crop&q=80&w=800',
    badge: 'Save 30%',
    description: 'Lamp, mat, and organizer combo.',
  },
]
